import { IAppState } from 'shared/common/state';

export function crossLinksSelector({ seoCrossLinks }: IAppState) {
  return seoCrossLinks;
}
